import request from '@/utils/request'

// 根据类型查询文章
export function getyylist(query) {
  return request({
    url: '/web/yy/getyylist',
    method: 'get',
    params: query
  })
}
